import Vue from 'vue';

function pluralize(amount: number, singular: string, plural: string) {
    return amount !== 1 ? plural : singular;
}

Vue.filter('pluralize', pluralize);

export default pluralize;
